import cloneDeep from 'lodash/cloneDeep';
import { SavedView } from '@/app/modules/saved-views/types';
import { MetricsGridConfig } from '../core';
import { SortOptionsNg, SortOptions } from '@/app/models';
import {
  SavedViewDeserializer,
  SavedViewDeserializerResponse,
} from '@/app/modules/saved-views/types';
import { GridSerializerContext } from '@/app/modules/saved-views/saved-views-serializer';
import { SavedViewSerialized } from '@/app/modules/saved-views/types';
import { createGridSerializer as defaultSerializer } from '@/app/modules/saved-views/saved-views-serializer';
import { savedViewDeserializer } from '@/app/modules/saved-views/saved-views-deserializer';

const repsCountTitle = 'main.core.common.counts.sales_reps.count';

export const customersSavedViewDeserializer: SavedViewDeserializer<
  MetricsGridConfig
> = async (config: MetricsGridConfig, view: SavedView) => {
  const saveViewResponse = await savedViewDeserializer(config, view);

  /*newConfig.config.groups.forEach((group) => {
    const uniqueTitle = group.columnSelectorTitle;
    if (view.columns.includes(uniqueTitle)) {
      if (uniqueTitle === repsCountTitle) {
        // This is a special case for the sales reps column. If the saved view includes the "sales reps count" column,
        // we need to check if the "sales reps" column was hidden with forceCanClose. If it was,
        // we show the count column but hide the original sales reps column.
        group.visible = group.forceCanClose;
      } else {
        group.visible = true;
      }
    } else {
      // Set visible to false for groups not in the saved view columns
      group.visible = false;
    }
  });*/

  const nameGroup = saveViewResponse.config.groups.find(
    (group) => group.id === 'sales-rep-name'
  );
  if (nameGroup?.visible) {
    const countGroup = saveViewResponse.config.groups.find(
      (group) => group.id === 'sales-rep-count'
    );
    if (countGroup) {
      countGroup.visible = false;
    }
  }

  const response: SavedViewDeserializerResponse<MetricsGridConfig> = {
    config: saveViewResponse.config,
    sorting: {
      key: view.sort.length > 0 ? view.sort[0].key : null,
      direction: view.sort.length > 0 ? view.sort[0].direction : null,
    },
  };

  return Promise.resolve(response);
};
export const customersSavedViewReducer = customersSavedViewDeserializer;

/**
 * Factory function that creates a getSerializer method for grid components.
 * This abstracts the common serialization logic used across multiple grid components.
 *
 * @param context - The context object containing grid configuration and services
 * @returns A function that returns the serializer function
 *
 * @example
 * ```typescript
 * class MyGridComponent {
 *   private getSerializer = createGridSerializer({
 *     gridName: this.gridName,
 *     gridConfig: this.gridConfig,
 *     gridSortingService: this.gridSortingService,
 *     componentName: 'MyGridComponent'
 *   });
 * }
 * ```
 */
export function createGridSerializer(
  context: GridSerializerContext
): () => () => SavedViewSerialized {
  return (): (() => SavedViewSerialized) => {
    return (): SavedViewSerialized => {
      // Handle both signals and plain objects
      const config = context.gridConfig();

      const result = defaultSerializer(context, true)()();

      /*  // The customers table has some strange logic, where if you hide the hideable sales reps column, it actually
      // hides that column, but then shows a "sales reps" column that is just a count of the sales reps.
      const salesReps = config?.groups.find(
        (grp) =>
          grp.columnSelectorTitle === repsCountTitle &&
          !grp.visible &&
          grp.forceCanClose
      );

      if (salesReps && result.columns.includes(repsCountTitle)) {
        result.columns = [...result.columns].filter(
          (col) => col !== repsCountTitle
        ); // Remove if it exists
      }*/

      return result as SavedViewSerialized;
    };
  };
}
